import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-37840038"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "main"
};
const _hoisted_2 = {
  class: "gridLayout"
};
const _hoisted_3 = {
  class: "cardModel"
};
const _hoisted_4 = {
  class: "card-title"
};
const _hoisted_5 = {
  class: "cardDescription"
};
const _hoisted_6 = {
  class: "block-field"
};
const _hoisted_7 = {
  class: "block-field__url"
};
const _hoisted_8 = {
  class: "idp-field-label"
};
const _hoisted_9 = {
  class: "idp-field-value"
};
const _hoisted_10 = {
  class: "block-field__entity-id"
};
const _hoisted_11 = {
  class: "idp-field-label"
};
const _hoisted_12 = {
  class: "idp-field-value"
};
const _hoisted_13 = {
  class: "cardModel saml-conf-card"
};
const _hoisted_14 = {
  class: "card-title"
};
const _hoisted_15 = {
  key: 0,
  class: "section upload-ok"
};
const _hoisted_16 = {
  class: "content has-text-centered"
};
const _hoisted_17 = {
  key: 1,
  class: "section"
};
const _hoisted_18 = {
  class: "content has-text-centered"
};
const _hoisted_19 = {
  key: 0,
  class: "idp-metadata-download-block"
};
const _hoisted_20 = {
  class: "card-title"
};
const _hoisted_21 = {
  class: "cardDescription"
};
const _hoisted_22 = {
  key: 0,
  class: "config-status-desc"
};
const _hoisted_23 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1));
const _hoisted_24 = {
  key: 1,
  class: "config-status-desc"
};
const _hoisted_25 = {
  class: "card-title"
};
const _hoisted_26 = {
  class: "cardDescription tableContainer"
};
const _hoisted_27 = {
  class: "card-title"
};
const _hoisted_28 = {
  class: "cardDescription"
};
const _hoisted_29 = {
  key: 0,
  class: "config-status-desc"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_MainTitle = _resolveComponent("MainTitle");
  const _component_Banner = _resolveComponent("Banner");
  const _component_w_icon = _resolveComponent("w-icon");
  const _component_w_standard_button = _resolveComponent("w-standard-button");
  const _component_Card = _resolveComponent("Card");
  const _component_GridItem = _resolveComponent("GridItem");
  const _component_el_upload = _resolveComponent("el-upload");
  const _component_AuthItemsAttributeTable = _resolveComponent("AuthItemsAttributeTable");
  const _component_AuthItemsAttributeMappingDialog = _resolveComponent("AuthItemsAttributeMappingDialog");
  const _component_CenterTop = _resolveComponent("CenterTop");
  const _directive_loading = _resolveDirective("loading");
  return _openBlock(), _createBlock(_component_CenterTop, null, {
    default: _withCtx(() => [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_MainTitle, {
      "breadcrumb-items": _ctx.breadcrumbItems
    }, {
      title: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.name) + " - " + _toDisplayString(_ctx.$t('authentications_management.auth_item.edit.saml2.breadcrumb').toString()), 1)]),
      _: 1
    }, 8, ["breadcrumb-items"]), !!_ctx.errorMsg ? (_openBlock(), _createBlock(_component_Banner, {
      key: 0,
      type: "error"
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.errorMsg), 1)]),
      _: 1
    })) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_2, [_createVNode(_component_GridItem, null, {
      default: _withCtx(() => [_createVNode(_component_Card, {
        class: "saml-conf-card"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createVNode(_component_w_icon, {
          icon: "download-outline",
          class: "card-title__icon"
        }), _createTextVNode(" " + _toDisplayString(_ctx.$t('authentications_management.auth_item.edit.saml2.sp_block.title').toString()), 1)]), _createElementVNode("div", _hoisted_5, [_createElementVNode("p", null, _toDisplayString(_ctx.$t('authentications_management.auth_item.edit.saml2.sp_block.subtitle').toString()), 1), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t('authentications_management.auth_item.edit.saml2.sp_block.url').toString()) + ": ", 1), _createElementVNode("span", _hoisted_9, [_createTextVNode(_toDisplayString(_ctx.urlASC) + " ", 1), _createVNode(_component_w_icon, {
          icon: "content-copy",
          class: "copy-icon",
          onClick: _cache[0] || (_cache[0] = $event => _ctx.copyOnClipboard(_ctx.urlASC))
        })])]), _createElementVNode("div", _hoisted_10, [_createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t('authentications_management.auth_item.edit.saml2.sp_block.entity_id').toString()) + ": ", 1), _createElementVNode("span", _hoisted_12, [_createTextVNode(_toDisplayString(_ctx.spEntityid) + " ", 1), _createVNode(_component_w_icon, {
          icon: "content-copy",
          class: "copy-icon",
          onClick: _cache[1] || (_cache[1] = $event => _ctx.copyOnClipboard(_ctx.spEntityid))
        })])])])]), _createVNode(_component_w_standard_button, {
          class: "card-action-button",
          type: "primary",
          minWidth: "100%",
          onClick: _ctx.downloadSPMetadata
        }, {
          default: _withCtx(() => [_createVNode(_component_w_icon, {
            icon: "download-outline"
          }), _createTextVNode(" " + _toDisplayString(_ctx.$t('authentications_management.auth_item.edit.saml2.sp_block.download').toString()), 1)]),
          _: 1
        }, 8, ["onClick"])])]),
        _: 1
      })]),
      _: 1
    }), _createVNode(_component_GridItem, null, {
      default: _withCtx(() => [_createVNode(_component_Card, {
        class: "saml-conf-card"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_createVNode(_component_w_icon, {
          icon: "upload-outline",
          class: "card-title__icon"
        }), _createTextVNode(" " + _toDisplayString(_ctx.$t('authentications_management.auth_item.edit.saml2.idp_block.title').toString()), 1)]), _createElementVNode("div", {
          class: _normalizeClass(`cardDescription ${_ctx.isIDPUpload ? 'idp-uploaded-card-desc' : ''}`)
        }, [_createVNode(_component_el_upload, {
          action: "#",
          "auto-upload": false,
          "show-file-list": false,
          accept: ".xml",
          drag: "",
          "on-change": _ctx.onFileSelected
        }, {
          default: _withCtx(() => [_ctx.isIDPUpload ? (_openBlock(), _createElementBlock("section", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_createVNode(_component_w_icon, {
            icon: "check",
            size: "30px",
            class: "uploaded-ok-icon is-success"
          }), _createTextVNode(" " + _toDisplayString(_ctx.$t('authentications_management.auth_item.edit.saml2.idp_block.uploaded_desc').toString()), 1)])])) : (_openBlock(), _createElementBlock("section", _hoisted_17, [_createElementVNode("div", _hoisted_18, [_createVNode(_component_w_icon, {
            icon: "upload-outline"
          }), _createElementVNode("p", null, _toDisplayString(_ctx.$t('authentications_management.auth_item.edit.saml2.idp_block.upload_desc').toString()), 1)])]))]),
          _: 1
        }, 8, ["on-change"])], 2), _ctx.isIDPUpload ? (_openBlock(), _createElementBlock("div", _hoisted_19, [_createVNode(_component_w_standard_button, {
          class: "card-action-button download-idp-btn",
          type: "default",
          minWidth: "100%",
          onClick: _ctx.downloadIDPMetadata
        }, {
          default: _withCtx(() => [_createVNode(_component_w_icon, {
            icon: "download-outline"
          }), _createTextVNode(" " + _toDisplayString(_ctx.$t('authentications_management.auth_item.edit.saml2.idp_block.download').toString()), 1)]),
          _: 1
        }, 8, ["onClick"])])) : _createCommentVNode("", true), _createVNode(_component_el_upload, {
          action: "#",
          "auto-upload": false,
          "show-file-list": false,
          accept: ".xml",
          "on-change": _ctx.onFileSelected
        }, {
          default: _withCtx(() => [_createVNode(_component_w_standard_button, {
            class: "card-action-button",
            minWidth: "100%"
          }, {
            default: _withCtx(() => [_createVNode(_component_w_icon, {
              icon: "upload-outline"
            }), _createTextVNode(" " + _toDisplayString(_ctx.isIDPUpload ? _ctx.$t('authentications_management.auth_item.edit.saml2.idp_block.upload_new').toString() : _ctx.$t('authentications_management.auth_item.edit.saml2.idp_block.upload').toString()), 1)]),
            _: 1
          })]),
          _: 1
        }, 8, ["on-change"])])]),
        _: 1
      })]),
      _: 1
    }), _createVNode(_component_GridItem, null, {
      default: _withCtx(() => [_createVNode(_component_Card, {
        class: "saml-conf-card"
      }, {
        default: _withCtx(() => [_createElementVNode("div", {
          class: _normalizeClass(`cardModel config-validate-card  ${!_ctx.isIDPUpload ? 'disabled' : ''}`)
        }, [_createElementVNode("div", _hoisted_20, [_createVNode(_component_w_icon, {
          icon: "check-circle-outline",
          class: "card-title__icon"
        }), _createTextVNode(" " + _toDisplayString(_ctx.$t('authentications_management.auth_item.edit.saml2.validate_block.title').toString()), 1)]), _createElementVNode("div", _hoisted_21, [_createElementVNode("p", null, _toDisplayString(_ctx.$t('authentications_management.auth_item.edit.saml2.validate_block.subtitle').toString()), 1), _ctx.isIDPUpload ? (_openBlock(), _createElementBlock("p", _hoisted_22, [_createVNode(_component_w_icon, {
          icon: "check",
          class: "status-icon is-success"
        }), _hoisted_23, _createElementVNode("span", null, _toDisplayString(_ctx.$t('authentications_management.auth_item.edit.saml2.validate_block.conf_validated_desc').toString()), 1)])) : _createCommentVNode("", true), !_ctx.isIDPUpload ? (_openBlock(), _createElementBlock("p", _hoisted_24, _toDisplayString(_ctx.$t('authentications_management.auth_item.edit.saml2.validate_block.prerequisite_desc').toString()), 1)) : _createCommentVNode("", true)]), _createVNode(_component_w_standard_button, {
          class: "card-action-button",
          type: "primary",
          minWidth: "100%",
          disabled: !_ctx.isIDPUpload,
          onClick: _ctx.createAuthRequest
        }, {
          default: _withCtx(() => [_createVNode(_component_w_icon, {
            icon: "cached"
          }), _createTextVNode(" " + _toDisplayString(_ctx.isAuthenticationValid ? _ctx.$t('authentications_management.auth_item.edit.saml2.validate_block.update_attr_btn').toString() : _ctx.$t('authentications_management.auth_item.edit.saml2.validate_block.proceed_to_test_btn').toString()), 1)]),
          _: 1
        }, 8, ["disabled", "onClick"])], 2)]),
        _: 1
      })]),
      _: 1
    }), _createVNode(_component_GridItem, null, {
      default: _withCtx(() => [_createVNode(_component_Card, {
        class: "saml-conf-card"
      }, {
        default: _withCtx(() => [_createElementVNode("div", {
          class: _normalizeClass(`cardModel ${!_ctx.isAuthenticationValid ? 'disabled' : ''}`)
        }, [_createElementVNode("div", _hoisted_25, [_createVNode(_component_w_icon, {
          icon: "sitemap",
          class: "card-title__icon"
        }), _createTextVNode(" " + _toDisplayString(_ctx.$t('authentications_management.auth_item.edit.saml2.map_attribute_block.title').toString()), 1)]), _createElementVNode("div", _hoisted_26, [_ctx.authItem.authItemAttributes?.length ? (_openBlock(), _createBlock(_component_AuthItemsAttributeTable, {
          key: 0,
          authItem: _ctx.authItem
        }, null, 8, ["authItem"])) : _createCommentVNode("", true)]), _createVNode(_component_w_standard_button, {
          class: "card-action-button",
          type: "primary",
          minWidth: "100%",
          disabled: !_ctx.isAuthenticationValid,
          onClick: _cache[2] || (_cache[2] = $event => _ctx.isMapAttributeModalActive = true)
        }, {
          default: _withCtx(() => [_createVNode(_component_w_icon, {
            icon: "sitemap"
          }), _createTextVNode(" " + _toDisplayString(_ctx.$t('authentications_management.auth_item.edit.saml2.map_attribute_block.submit_btn').toString()), 1)]),
          _: 1
        }, 8, ["disabled"])], 2)]),
        _: 1
      })]),
      _: 1
    }), _createVNode(_component_GridItem, null, {
      default: _withCtx(() => [_createVNode(_component_Card, {
        class: "saml-conf-card"
      }, {
        default: _withCtx(() => [_createElementVNode("div", {
          class: _normalizeClass(`cardModel link-platform-card ${!_ctx.isAuthenticationValid || !_ctx.isCreateAuthLink ? 'disabled' : ''}`)
        }, [_createElementVNode("div", _hoisted_27, [_createVNode(_component_w_icon, {
          icon: "link-lock",
          class: "card-title__icon"
        }), _createTextVNode(" " + _toDisplayString(_ctx.$t('authentications_management.auth_item.edit.saml2.platform_link_block.title').toString()), 1)]), _createElementVNode("div", _hoisted_28, [_ctx.isAuthenticationValid ? (_openBlock(), _createElementBlock("div", _hoisted_29, [_createVNode(_component_w_icon, {
          icon: "check",
          class: "status-icon is-success"
        }), _createElementVNode("p", null, _toDisplayString(_ctx.$t('authentications_management.auth_item.edit.saml2.platform_link_block.platform_linked_desc').toString()), 1)])) : _createCommentVNode("", true)]), _createVNode(_component_w_standard_button, {
          class: "card-action-button",
          type: "primary",
          minWidth: "100%",
          disabled: !_ctx.isAuthenticationValid || !_ctx.isCreateAuthLink,
          onClick: _cache[3] || (_cache[3] = $event => _ctx.goToAuthLinkCreation())
        }, {
          default: _withCtx(() => [_createVNode(_component_w_icon, {
            icon: "link-lock"
          }), _createTextVNode(" " + _toDisplayString(_ctx.$t('authentications_management.auth_item.edit.saml2.platform_link_block.submit_btn').toString()), 1)]),
          _: 1
        }, 8, ["disabled"])], 2)]),
        _: 1
      })]),
      _: 1
    })]), _ctx.authItem ? (_openBlock(), _createBlock(_component_AuthItemsAttributeMappingDialog, {
      key: 1,
      authItem: _ctx.authItem,
      isMapAttributeModalActive: _ctx.isMapAttributeModalActive,
      onDialogClose: _cache[4] || (_cache[4] = $event => _ctx.isMapAttributeModalActive = false)
    }, null, 8, ["authItem", "isMapAttributeModalActive"])) : _createCommentVNode("", true)])), [[_directive_loading, _ctx.loading]])]),
    _: 1
  });
}